/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetPublicTileRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/tile_messages.pb'
import {GetPublicTileResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/tile_messages.pb'


export const getPublicTile = (request: GetPublicTileRequest, options?: CashRequestOptions) => post<GetPublicTileRequest, GetPublicTileResponse>("/2.0/cash/get-public-tile", request, {...options, rejectOnError: true })